import { motion } from "framer-motion";
import { Instagram, Mail, MapPin, ArrowUpRight, Phone } from "lucide-react";

const Contact = () => {
  return (
    <footer
      id="contact"
      data-testid="contact-section"
      className="bg-[#2A2A2A] text-[#F9F8F6] relative"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-8 md:gap-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-7"
          >
            <p className="overline text-[#F9F8F6]/60 mb-6">Get in touch</p>
            <h2
              data-testid="contact-heading"
              className="serif text-5xl md:text-7xl lg:text-[5.2rem] font-light leading-[1] tracking-tight"
            >
              Let's make <br />
              something <span className="italic text-[#C48B71]">honest</span>.
            </h2>
            <div className="mt-10 flex flex-col gap-3 items-start">
              <a
                href="mailto:manevzion@gmail.com"
                data-testid="contact-email-link"
                className="flex w-fit items-center gap-3 serif text-2xl md:text-3xl link-underline"
              >
                manevzion@gmail.com
                <ArrowUpRight size={22} strokeWidth={1.2} />
              </a>
              <a
                href="tel:+13035151924"
                data-testid="contact-phone-link"
                className="flex w-fit items-center gap-3 serif text-xl md:text-2xl link-underline text-[#F9F8F6]/85"
              >
                <Phone size={18} strokeWidth={1.2} />
                303 · 515 · 1924
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="col-span-12 md:col-span-4 md:col-start-9 space-y-8"
          >
            <div>
              <p className="overline text-[#F9F8F6]/60 mb-2">Studio</p>
              <p className="serif text-xl flex items-center gap-2">
                <MapPin size={16} strokeWidth={1.2} />
                Denver Metro & surrounding cities
              </p>
              <p className="text-[#F9F8F6]/70 text-sm mt-1 font-light">
                By appointment only · Travels worldwide
              </p>
            </div>

            <div>
              <p className="overline text-[#F9F8F6]/60 mb-2">Hours</p>
              <p className="serif text-xl">Tue – Sat · 9 to 5</p>
              <p className="text-[#F9F8F6]/70 text-sm mt-1 font-light">
                Sessions held on weekends
              </p>
            </div>

            <div>
              <p className="overline text-[#F9F8F6]/60 mb-3">Find me</p>
              <div className="flex gap-5">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="contact-instagram"
                  className="flex items-center gap-2 link-underline text-[#F9F8F6]"
                >
                  <Instagram size={16} strokeWidth={1.2} />
                  Instagram
                </a>
                <a
                  href="mailto:manevzion@gmail.com"
                  data-testid="contact-mail"
                  className="flex items-center gap-2 link-underline text-[#F9F8F6]"
                >
                  <Mail size={16} strokeWidth={1.2} />
                  Email
                </a>
                <a
                  href="tel:+13035151924"
                  data-testid="contact-phone"
                  className="flex items-center gap-2 link-underline text-[#F9F8F6]"
                >
                  <Phone size={16} strokeWidth={1.2} />
                  Call
                </a>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom bar */}
        <div className="mt-20 pt-8 border-t border-[#F9F8F6]/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="serif text-2xl">
            <span className="italic font-light">Mane</span>
            <span className="font-normal">Vzion</span>
            <span className="text-[#C48B71]">.</span>
          </p>
          <div className="flex items-center gap-6">
            <a
              href="/peek"
              data-testid="footer-for-clients"
              className="overline link-underline text-[#F9F8F6]/80"
            >
              For Clients
            </a>
            <span className="text-[#F9F8F6]/20">·</span>
            <p className="overline text-[#F9F8F6]/50">
              © {new Date().getFullYear()} ManeVzion Photography
            </p>
          </div>
          <p className="overline text-[#F9F8F6]/50">
            Crafted with care · Denver, CO
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Contact;
